module.exports = __webpack_public_path__ + "img/live.98013a4d.svg";